import { operatorApiFetch } from './apiService';

// Conservative conversion — same runtime as the original .js. Body is
// pre-stringified here (not relying on apiService's auto-serialize); apiService
// detects strings and skips re-stringifying, so this is safe.

export const warehouseService = {
  // 列表
  getRecords: async (params: Record<string, unknown>): Promise<any> => {
    const response = await operatorApiFetch('warehouses/get_records', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params: Record<string, unknown>): Promise<any> => {
    const response = await operatorApiFetch('warehouses/get_ids', {
      method: 'POST',
      body: JSON.stringify(params),
    });
    return response.json();
  },

  // 建立
  create: async (data: Record<string, unknown>): Promise<any> => {
    const response = await operatorApiFetch('warehouses', {
      method: 'POST',
      body: JSON.stringify({ warehouse: data }),
    });
    return response.json();
  },

  // 更新
  update: async (id: string, data: Record<string, unknown>): Promise<any> => {
    const response = await operatorApiFetch(`warehouses/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ warehouse: data }),
    });
    return response.json();
  },

  // 單一資源
  get: async (id: string): Promise<any> => {
    const response = await operatorApiFetch(`warehouses/${id}`);
    return response.json();
  },

  // 獲取倉庫列表 (index)
  fetchList: async (params: Record<string, unknown> = {}): Promise<any> => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach((key) => queryParams.append(key, String(params[key])));

    const response = await operatorApiFetch(`warehouses?${queryParams.toString()}`);
    return response.json();
  },
};

export default warehouseService;
